<template>
	<div>
		<span style="font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:red;">
			{{lable}}
		</span>
		<VsSelect style="display: inline-block;background:rgba(255,255,255,1);border-radius:3px;"
			:lablewidth="lablewidth" :width="width" :classtype="classtype" v-model="select.value"
			:loopdata="select.droplist" :keys="['CKMC']" @click="fnInputSelect" @input="fnInputAct"
			@on-enter="fnEnterpressAct" @inputserch="fnInputSelect" :requiremore="select.requiremore"
			@require="fnInputSelect" @on-confirm="fnSelectConfirm">
		</VsSelect>
	</div>
</template>

<script>
	export default {
		props: {
			loopdata: {},
			keys: {},
			lablewidth: {},
			width: {},
			lable: {},
			classtype: {},
			returnkey: {},
			selectValue: {},
		},
		model: {
			prop: 'selectValue',
			event: 'on-model'
		},
		watch: {
			selectValue(val) {
				//console.log(val)
				//this.select.value=val
			}
		},
		data() {
			return {
				select: {
					value: '',
					PageNo: '1',
					PageSize: '50',
					requiremore: true,
					droplist: [],
				},
			}
		},
		activated() {
			let params = this.$fun.GetUserConstant()
			params.CKMC = this.select.value
			// console.log(params)
			this.$Api.ErpCKinfoGet(params).then((res) => {
				// console.log(res)
				this.select.droplist = res.data.ck
				this.select.requiremore = false
			})
		},
		mounted() {
			let params = this.$fun.GetUserConstant()
			params.CKMC = this.select.value
			// console.log(params)
			this.$Api.ErpCKinfoGet(params).then((res) => {
				// console.log(res)
				this.select.droplist = res.data.ck
				this.select.requiremore = false
			})
		},
		methods: {
			fnInputAct() {
				this.select.droplist = []
				this.select.requiremore = true
				this.fnSelectConfirm()
				this.$emit('input')
			},
			fnInputSelect() {
				//	this.droplist=''
				this.select.value = ''
				this.$emit('on-model', "")
				if (this.select.requiremore) {
					let params = this.$fun.GetUserConstant()
					params.CKMC = this.select.value
					this.$Api.ErpCKinfoGet(params).then((res) => {
						// console.log(res)
						this.select.droplist = res.data.ck
						this.select.requiremore = false

					})
				}
			},
			fnSelectConfirm(data) {
				// console.log(data)
				if (data) {
					if (this.returnkey) {
						// console.log(data[this.returnkey])
						this.$emit('on-model', data[this.returnkey])
						this.$emit('on-select', data)
					} else {
						this.$emit('on-select', data)
					}
				} else {
					this.$emit('on-select', "")
				}


			},
			fnEnterpressAct($event) {
				this.$emit('on-enter', $event)
			}

		}
	}
</script>

<style>
</style>
